export const TrackingStatusMapping = {
  InactiveDueToTagUnavailable: {
    i18nKey: 'GoalSelector_TrackingStatus_Value_InactiveDueToTagUnavailable',
  },
  NoRecentConversion: {
    i18nKey: 'GoalSelector_TrackingStatus_Value_NoRecentConversion',
  },
  RecordingConversions: {
    i18nKey: 'GoalSelector_TrackingStatus_Value_RecordingConversions',
  },
  TagInactive: {
    i18nKey: 'GoalSelector_TrackingStatus_Value_TagInactive',
  },
  Unverified: {
    i18nKey: 'GoalSelector_TrackingStatus_Value_Unverified',
  },
};

export const GoalCategories = {
  AddToCart: {
    value: 'AddToCart',
    i18nKey: 'Segment_Goal_Category_AddToCart',
  },
  BeginCheckout: {
    value: 'BeginCheckout',
    i18nKey: 'Segment_Goal_Category_BeginCheckout',
  },
  BookAppointment: {
    value: 'BookAppointment',
    i18nKey: 'Segment_Goal_Category_BookAppointment',
  },
  Contact: {
    value: 'Contact',
    i18nKey: 'Segment_Goal_Category_Contact',
  },
  Download: {
    value: 'Download',
    i18nKey: 'Segment_Goal_Category_Download',
  },
  GetDirections: {
    value: 'GetDirections',
    i18nKey: 'Segment_Goal_Category_GetDirections',
  },
  InStoreVisit: {
    value: 'InStoreVisit',
    i18nKey: 'Segment_Goal_Category_InStoreVisit',
  },
  Other: {
    value: 'Other',
    i18nKey: 'Segment_Goal_Category_Other',
  },
  OutboundClick: {
    value: 'OutboundClick',
    i18nKey: 'Segment_Goal_Category_OutboundClick',
  },
  PageView: {
    value: 'PageView',
    i18nKey: 'Segment_Goal_Category_PageView',
  },
  Purchase: {
    value: 'Purchase',
    i18nKey: 'Segment_Goal_Category_Purchase',
  },
  RequestQuote: {
    value: 'RequestQuote',
    i18nKey: 'Segment_Goal_Category_RequestQuote',
  },
  Signup: {
    value: 'Signup',
    i18nKey: 'Segment_Goal_Category_SignUp',
  },
  SubmitLeadForm: {
    value: 'SubmitLeadForm',
    i18nKey: 'Segment_Goal_Category_SubmitLeadForm',
  },
  // Temp fix to unblock the PR
  // TODO: need to resolve the typo in MT
  Subcribe: {
    value: 'Subcribe',
    i18nKey: 'Segment_Goal_Category_Subscribe',
  },
  None: {
    value: 'None',
    i18nKey: 'Segment_Goal_Category_Unassigned',
  },
};


export const GoalOptions = {
  Goals: {
    value: 'goals',
    i18nKey: 'Campaign_Goals_Option_Goals',
  },
  GoalSets: {
    value: 'goalsets',
    i18nKey: 'Campaign_Goals_Option_GoalSets',
  },
};

export const Scopes = Object.freeze({
  ACCOUNT: 'account-scope',
  CAMPAIGN: 'campaign-scope',
});
export const ScopeOptions = [
  { id: Scopes.ACCOUNT, text: 'Campaign_Goals_Account_Level_Label' },
  { id: Scopes.CAMPAIGN, text: 'Campaign_Goals_Campaign_Level_Label' },
];
